<template>
  <div class="soft-container">
    <div class="soft-title">{{ languages.softUninstall.title }}</div>
    <div class="soft-empty" v-if="uninstallSoftwareList.length === 0 && !uninstallLoadingFlag">
      <img src="~/assets/pics/noresult.png" alt="" />
      <p>{{ languages.softUninstall.uninstallEmpty }}</p>
    </div>
    <el-scrollbar height="100px" class="soft-list">
      <div class="single-container" v-for="(item, index) in uninstallSoftwareList" :key="index">
        <div class="soft-preview">
          <div class="soft-info">
            <img class="img-preview" :src="item.icon" alt="" />
            <div>
              <div class="soft-name">
                {{ item.display }}
                <span class="soft-desc">
                  {{
                    item.size > 0
                      ? `${languages.softInstall.softsize}: ${Math.round(item.size / 1024)}MB`
                      : ''
                  }}
                </span>
              </div>
              <div class="soft-desc">
                {{
                  item.installDate === ''
                    ? ''
                    : `${languages.softUninstall.installDate}: ${item.installDate}`
                }}
              </div>
              <div class="soft-desc">
                {{
                  item.version ? `${languages.softUninstall.installVersion}: ${item.version}` : ''
                }}
              </div>
            </div>
          </div>
          <div class="button-container">
            <el-button
              type="danger"
              @click="operateUninstall(item, index)"
              :loading="uninstallLoading && currentIndex === index"
              >{{ languages.uninstall }}</el-button
            >
          </div>
        </div>
      </div>
    </el-scrollbar>
    <info-dialog
      :languages="languages"
      :type="infoType"
      :confirm="infoConfirm"
      :show="dialogInfoVisible"
      :tips="infoTips"
      :submitting="submitting"
    ></info-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { Loading } from 'element-ui';
import moment from 'moment';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  components: {
    InfoDialog,
  },
  inject: ['homeTemplate'],
  data() {
    return {
      pvId: '',
      encryptPath: '',
      softKey: '',
      loading: {},
      uninstallLoading: false,
      infoType: 'info',
      infoConfirm: false,
      dialogInfoVisible: false,
      infoTips: {},
      submitting: false,
      currentIndex: 0,
      queryInterval: null,
    };
  },
  computed: {
    ...mapState([
      'languages',
      'userInfo',
      'deviceName',
      'recommendSoftware',
      'recommendSoftwareEn',
      'isAdministrator',
      'uninstallLoadingFlag',
      'uninstallSoftwareList',
      'socketStatus',
    ]),
  },
  created() {
    this.setPageNow('SoftwareUninstall');
    this.setUninstallLoadingFlag(true);
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setSoftCount(0);
    this.setShowFooter(true);
    this.generateUninstallApplication();
    this.pvId = ubtRegister('Uninstall');
    this.setPvId(this.pvId);
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setIsRunning',
      'setSelectSoftDetails',
      'setUninstallSearch',
      'setSoftTabPage',
      'setErrorTips',
      'setPvId',
      'setSoftCount',
      'setUninstallSoftwareList',
      'setUninstallLoadingFlag',
    ]),
    ...mapActions(['softwareInstall', 'saveLog', 'getAllSoftList', 'getSoftAllHashList', 'getSoftHashList']),
    async generateUninstallApplication() {
      try {
        this.setIsRunning(true);
        this.loading = Loading.service({
          fullscreen: true,
          text: this.languages.softUninstall.queryloadingText,
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const uninstallInfoList = await this.getUninstallSoftWare();
        let uninstallInfoListAdf = [];
        if (!this.isAdministrator) {
          this.homeTemplate.initSoftModel('adf', async () => {
            uninstallInfoListAdf = await this.getUninstallSoftWare();
            const displayNameSet = new Set(uninstallInfoList.map((item) => item.DisplayName));
            uninstallInfoListAdf.forEach((uninstallInfo) => {
              if (!displayNameSet.has(uninstallInfo.DisplayName)) {
                uninstallInfoList.push(uninstallInfo);
                displayNameSet.add(uninstallInfo.DisplayName);
              }
            });
            await this.filtUninstallSoftwareList(uninstallInfoList);
          });
        } else {
          await this.filtUninstallSoftwareList(uninstallInfoList);
        }
      } catch (error) {
        console.log(`generateUninstallApplication failed, error: ${error}`);
      }
    },

    async filtUninstallSoftwareList(uninstallInfoList) {
      const softCnRes = await this.getAllSoftList('cn');
      const softEnRes = await this.getAllSoftList('en');
      const totalSoftList = softCnRes.concat(softEnRes);
      if (totalSoftList.length === 0) {
        this.loading.close();
        this.homeTemplate.showError('apierror');
        return;
      }
      const canUninstallList = totalSoftList.filter(
        (soft) => soft.uninstall === 1 && soft.regName !== '',
      );
      let uninstallSoftwareList = [];
      for (let index = 0; index < uninstallInfoList.length; index += 1) {
        const uninstallInfo = uninstallInfoList[index];
        const displayName = uninstallInfo.DisplayName.toUpperCase();
        for (let softIdx = 0; softIdx < canUninstallList.length; softIdx += 1) {
          const soft = canUninstallList[softIdx];
          const regName = soft.regName.toUpperCase();
          const matchType = soft.upgradeMatchType;
          let regMatchFlag = displayName.includes(regName);
          if (matchType === 'equals') {
            regMatchFlag = displayName === regName;
          } else if (matchType === 'startWith') {
            regMatchFlag = displayName.startsWith(regName);
          }
          let fileExistFlag = true;
          const uninstallStringUpper = uninstallInfo.UninstallString.toUpperCase();
          if (uninstallInfo.UninstallFileHash === '' && !uninstallStringUpper.startsWith('MSIEXEC.EXE')) {
            fileExistFlag = false;
          }
          if (regMatchFlag && fileExistFlag) {
            console.log(`flag: ${regMatchFlag}, displayName: ${displayName}, reg: ${regName}, matchType: ${matchType}`);
            uninstallSoftwareList.push({
              id: soft.id,
              name: soft.name,
              icon: soft.icon,
              display: uninstallInfo.DisplayName,
              size: uninstallInfo.EstimatedSize,
              version: uninstallInfo.DisplayVersion,
              installDate: uninstallInfo.InstallDate
                ? moment(uninstallInfo.InstallDate, 'YYYYMMDD').format('YYYY-MM-DD')
                : '',
              uninstallString: uninstallInfo.UninstallString,
              hash: uninstallInfo.UninstallFileHash,
              uninstallRestartFlag: soft.uninstallRestartFlag,
            });
            break;
          }
        }
      }
      console.log(uninstallSoftwareList);
      if (!this.isAdministrator) {
        const softIdList = uninstallSoftwareList.map((uninstallSoft) => uninstallSoft.id);
        const uninstallHashList = await this.getSoftHashList(softIdList);
        console.log('soft uninnstall hash list ', uninstallHashList);
        const hashObject = {};
        for (let index = 0; index < uninstallHashList.length; index += 1) {
          const softHashItem = uninstallHashList[index];
          hashObject[softHashItem.softwareId] = softHashItem.hashList;
        }
        console.log('soft uninnstall hash object ', hashObject);
        uninstallSoftwareList = uninstallSoftwareList.filter((uninstallSoft) => {
          let flag = false;
          if (uninstallSoft.uninstallString.toUpperCase().startsWith('MSIEXEC.EXE')) {
            flag = true;
            console.log(`soft uninnstall hash check, ${uninstallSoft.display}, match msi, flag: ${flag}`);
            return flag;
          }
          if (uninstallSoft.id in hashObject) {
            const hashList = hashObject[uninstallSoft.id];
            flag = hashList.includes(uninstallSoft.hash);
          }
          console.log(`soft uninnstall hash check, ${uninstallSoft.display}, flag: ${flag}`);
          return flag;
        });
      }
      localStorage.setItem('UNINSTALL_SOFTWARE', JSON.stringify(uninstallSoftwareList));
      this.setUninstallSoftwareList(uninstallSoftwareList);
      this.setSoftCount(this.uninstallSoftwareList.length);
      this.setUninstallLoadingFlag(false);
      this.loading.close();
      this.setIsRunning(false);
    },

    getUninstallSoftWare() {
      return new Promise((resolve, reject) => {
        const toolData = {
          lan: 'tools',
          type: 'silent',
          username: `${this.userInfo.username}`,
        };
        const socketDatas = tools.toUnicode(JSON.stringify(toolData));
        const runCmd = `({"level":"user", "method":"uninstall_query", "data":"${socketDatas}"})`;
        setTimeout(() => {
          socket.sendSocket(2, runCmd, (rt) => {
            try {
              const rst = JSON.parse(rt);
              console.log(rst);
              if (rst.result === 'success' && rst.data !== 'Tool Exited') {
                const info = JSON.parse(rst.data);
                resolve(info);
              }
            } catch (err) {
              reject(err);
            }
          });
        }, 2000);
      });
    },
    async operateUninstall(uninstallInfo, softIdx) {
      if (this.uninstallLoading) {
        this.$message.info(this.languages.softUninstall.uninstallingRemind);
        return;
      }
      this.setIsRunning(true);
      this.saveLog({
        title: 'Click Uninstall button',
        target: 'operateUninstall',
        softwareName: uninstallInfo.name,
        softwareId: uninstallInfo.id,
        description: uninstallInfo.display,
        reserve1: 'SoftwareUninstall > operateUninstall',
      });
      this.currentIndex = softIdx;
      this.uninstallLoading = true;
      console.log(uninstallInfo);
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: uninstallInfo.id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.uninstallFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'softTaskCreate',
          softwareName: uninstallInfo.name,
          softwareId: uninstallInfo.id,
          description: res.data,
          reserve1: 'SoftwareUninstall > operateUninstall',
        });
        this.setErrorTips(`Api Error in operateUninstall> ${res.error_msg}`);
        this.uninstallLoading = false;
        this.setIsRunning(false);
        return;
      }
      this.encryptPath = res.data.encryptPath;
      this.softKey = res.data.key;
      const uninstallHashList = await this.getSoftAllHashList(uninstallInfo.id);
      if (!this.isAdministrator) {
        this.homeTemplate.initSoftModel('adf', () => {
          this.uninstallHandler(uninstallInfo, uninstallHashList);
        });
      } else {
        this.uninstallHandler(uninstallInfo, uninstallHashList);
      }
    },
    uninstallHandler(uninstallInfo, uninstallHashList) {
      const remindMsg = this.$message({
        showClose: true,
        message: this.languages.softUninstall.uninstallProgramRemind,
        duration: 0,
        type: 'success',
      });
      const encodedValue = btoa(unescape(encodeURIComponent(uninstallInfo.uninstallString)));
      const uninstallDatas = {
        username: this.userInfo.username,
        softid: uninstallInfo.id,
        lan: this.languages.lan,
        path: this.encryptPath,
        key: this.softKey,
        type: '',
        uninstallHashList,
        uninstallString: encodedValue,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(uninstallDatas));
      const level = this.isAdministrator ? 'user' : 'adf';
      const method = uninstallInfo.uninstallString.toLowerCase().startsWith('msiexec.exe')
        ? 'uninstall_msi'
        : 'uninstall_exe';
      const command = `({"level":"${level}", "method":"${method}", "data":"${socketDatas}"})`;
      this.saveLog({
        title: 'uninstall_process',
        target: 'uninstallHandler',
        softwareName: uninstallInfo.name,
        softwareId: uninstallInfo.id,
        description: 'uninstall start',
        reserve1: 'SoftwareUninstall > uninstallHandler',
        reserve4: JSON.stringify(command),
      });
      socket.sendSocket(2, command, (rt) => {
        try {
          const rst = JSON.parse(rt);
          console.log(rst);
          if (rst.result === 'failed') {
            remindMsg.close();
            if (rst.error === 'ExeNotExisted') {
              this.$message.error(this.languages.softUninstall.fileNotExistedError);
            } else if (rst.error === 'NotInHashList') {
              this.$message.error(this.languages.softUninstall.notInHashListError);
            } else {
              this.$message.error(rst.error);
            }
            this.uninstallLoading = false;
            this.setIsRunning(false);
            const logInfo = {
              name: uninstallInfo.display,
              ver: uninstallInfo.version,
              hash: rst.data,
              uninstallString: uninstallInfo.uninstallString,
            };
            this.saveLog({
              title: 'uninstall_error',
              target: 'uninstallHandler',
              softwareName: uninstallInfo.name,
              softwareId: uninstallInfo.id,
              description: rst.error,
              reserve1: 'SoftwareUninstall > uninstallHandler',
              reserve4: JSON.stringify(logInfo),
            });
            ubtSendTrace(
              245278,
              'sw_install',
              'uninstall_fail',
              uninstallInfo.name,
              uninstallInfo.id,
              '',
              this.pvId,
            );
            if (!this.isAdministrator) {
              this.homeTemplate.initSoftModel('ads', () => {
                this.generateUninstallApplication();
              });
            }
            return;
          }
          if (rst.data === 'Uninstall Finished') {
            remindMsg.close();
            const uninstallResult = JSON.parse(rst.info);
            this.uninstallLoading = false;
            const finishFlag = uninstallResult.realUninstalledFlag || uninstallResult.data === '0';
            if (finishFlag) {
              if (!this.isAdministrator) {
                this.homeTemplate.initSoftModel('ads', () => {
                  this.generateUninstallApplication();
                  this.$message.success(this.languages.softUninstall.uninstallFinished);
                });
              } else {
                this.generateUninstallApplication();
                this.$message.success(this.languages.softUninstall.uninstallFinished);
              }
              if (uninstallInfo.uninstallRestartFlag === 1) {
                this.showDialog(
                  this.languages.softUninstall.finishRemind,
                  this.languages.softUninstall.restartRemind,
                  'warn',
                );
              }
            } else if (!this.isAdministrator) {
              this.homeTemplate.initSoftModel('ads');
            }
            this.saveLog({
              title: 'uninstall_success',
              target: 'uninstallHandler',
              softwareName: uninstallInfo.name,
              softwareId: uninstallInfo.id,
              description: rst.info,
              reserve1: 'SoftwareUninstall > uninstallHandler',
              reserve4: rt,
            });
            ubtSendTrace(
              245278,
              'sw_install',
              'uninstall_suc',
              uninstallInfo.name,
              uninstallInfo.id,
              'selfhelp',
              this.pvId,
            );
            this.setIsRunning(false);
          }
          if (rst.data === 'Software Uninstalling') {
            this.$message.warning(this.languages.softUninstall.uninstallProcesRunningWarn);
          }
        } catch (err) {
          console.log(err);
          remindMsg.close();
          this.$message.error(err);
          this.setIsRunning(false);
          this.uninstallLoading = false;
          if (!this.isAdministrator) {
            this.homeTemplate.initSoftModel('ads');
          }
          this.saveLog({
            title: 'uninstall_error',
            target: 'uninstallHandler',
            softwareName: uninstallInfo.name,
            softwareId: uninstallInfo.id,
            description: 'uninstallHandler catch error',
            reserve1: 'SoftwareUninstall > uninstallHandler',
            reserve4: err,
          });
        }
      });
    },
    showDialog(title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
    },
    hideInfoDialog() {
      this.dialogInfoVisible = false;
      this.uninstallLoading = false;
    },
    reloadUninstall(flag) {
      if (flag) {
        this.generateUninstallApplication();
      }
    },
    reloadHandler(softIdx) {
      this.currentIndex = softIdx;
    },
  },

  beforeDestroy() {
    this.setUninstallSearch('');
    const recommendList =
      this.languages.lan === 'cn' ? this.recommendSoftware : this.recommendSoftwareEn;
    this.setSoftTabPage(recommendList.length > 0 ? 'recommend' : 'common');
    this.setSelectSoftDetails(recommendList.length > 0 ? 'recommend' : 'common');
    console.log('Uninstall Software Page destory');
  },
};
</script>
<style lang="scss" scoped>
.soft-container {
  background-color: #fff;
  padding: 0 10px;
  // position: relative;
}
.soft-title {
  height: 42px;
  font-size: 16px;
  line-height: 42px;
  color: #666;
  margin-left: 5px;
}
.soft-empty {
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: center;
  align-items: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 200px;
    height: 200px;
  }
  .el-icon-loading {
    font-size: 70px;
    color: #ccc;
  }
  p {
    color: #999;
  }
}
.soft-list {
  height: calc(100vh - 142px);
}
.single-container {
  height: 86px;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  position: relative;
  margin-bottom: -1px;
  margin-left: 2px;
  margin-right: 5px;
}
.soft-preview {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .soft-info {
    display: flex;
  }
  .img-preview {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    margin-top: 5px;
  }
  .soft-name {
    font-weight: 700;
    line-height: 24px;
    color: #333;
    span {
      margin-left: 10px;
      // color: #409bff;
      font-weight: 400;
      font-size: 13px;
    }
  }
  .soft-desc {
    line-height: 16px;
    font-size: 13px;
    color: #999;
    max-width: 520px;
  }
  .button-container {
    display: flex;
    position: absolute;
    right: 10px;
  }
}
</style>
